import { loadJS, createLoaded } from './utils';

/**
 * 多语言云资源管理器
 */
const Theme = class {
  constructor($config, $ctx) {
    this.$installer = {
      /**
       * 主题配置
       */
      themeConfig: null,
      /**
       * 主题属性
       */
      prop: null,
      /**
       * 主题样式
       */
      style: null,
      /**
       * 默认主题配置加载方法（可重写）
       */
      load: (biz) => new Promise((resolve, reject) => {
        // 挂载全局资源安装函数（JSONP回调）
        window[$config.theme.callbackMethod] = data => { resolve(data); };
        // 远程加载资源JS
        const themeUrl = `${$config.theme.file.format({
          runtime: $ctx.runtime,
          appName: $config.log.appName,
          biz,
        })}?t=${window.parseInt((new Date().getTime() / $config.theme.cacheExpires))}`;
        loadJS(themeUrl).catch(error => {
          console.warn(`load theme [${themeUrl}] error:`, error);
          reject(error);
        });
      }),
      /**
       * 安装主题
       */
      install: createLoaded(biz => ($config.theme ? this.$installer.load(biz).then(config => {
        this.$installer.themeConfig = config;
        // 安装主题配置
        this.$installer.setupStyle(config?.default?.style);
        this.$installer.setupProp(config?.default?.prop);
        Object.setPrototypeOf(this, this.$installer.prop ?? {});
      }) : Promise.resolve())),

      setupStyle: (style) => {
        if (style) {
          this.$installer.style = {};
          const loadStyle = (styleLayer, prefix) => {
            let styleValue = null;
            for (const name in styleLayer) {
              styleValue = styleLayer[name];
              if (styleValue && typeof styleValue === 'object') {
                loadStyle(styleValue, `${prefix}${name}-`);
              } else {
                this.$installer.style[`${prefix}${name}`] = styleValue;
              }
            }
          };
          loadStyle(style, '--');

          // #region 生命全局样式变量
          const styleContent = [':root{'];
          for (const name in this.$installer.style) {
            styleContent.push(`${name}:${this.$installer.style[name]};`);
          }
          styleContent.push('}');
          const el = document.createElement('style');
          el.appendChild(document.createTextNode(styleContent.join('')));
          document.head.appendChild(el);
          // #endregion
        }
      },

      setupProp: (prop) => {
        this.$installer.prop = prop ?? {};
        // #region 添加主文档favicon图标
        if (this.$installer.prop.favicon) {
          const el = document.createElement('link');
          el.rel = 'icon shortcut bookmark';
          el.type = 'image/ico';
          el.href = this.$installer.prop.favicon;
          document.head.appendChild(el);
        }
        // #endregion
      },
    };
  }
};

export default Theme;
